import React from 'react'
import { Badge, Popover, List, Avatar, Button, Divider } from 'antd'
import { BellFilled, AlertTwoTone } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'
import { delAll, del } from '../../reducers/notificationsReducer'
import { DateTime } from 'luxon'
import './DropDownNotification.css'
import { Styled } from 'styled-components'

const DropDownNotification = () => {
  const dispatch = useDispatch()
  const notifications = useSelector((state) => state.notifications)

  const handleClear = () => {
    dispatch(delAll())
  }

  const handleItemClick = (item) => {
    dispatch(del(item._id))
  }

  const getNoticeData = (data) => {
    return data.map((item) => {
      let avatar
      switch (item.type) {
        case 'follow':
        case 'bookmark':
          avatar =
            'https://gw.alipayobjects.com/zos/rmsportal/GvqBnKhFgObvnSGkDsje.png'
          break
        case 'like':
          avatar =
            'https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png'
          break
        case 'comment':
          avatar =
            'https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png'
          break
        case 'admin':
          avatar =
            'https://gw.alipayobjects.com/zos/rmsportal/kISTdvpyTAhtGxpovNWd.png'
          break
        case 'alert':
          avatar = <AlertTwoTone />
          break
        default:
          avatar = null
      }

      return {
        ...item,
        avatar,
        datetime: DateTime.fromISO(item.updatedAt).toRelative()
      }
    })
  }

  const content = (
    <div className="notice-list">
      {notifications.length === 0 ? (
        <div style={{ padding: 20 }}>No new notifications</div>
      ) : (
        <div className="notificationScroll">
          <span
            style={{ color: '#146eecff', fontSize: '24px', fontWeight: 500 }}
          >
            Notifications {notifications.length}
          </span>
          <Divider style={{ margin: '8px 0' }}></Divider>
          <List
            itemLayout="horizontal"
            dataSource={getNoticeData(notifications)}
            renderItem={(item) => (
              <List.Item
                style={{ padding: '5px 12px' }}
                actions={[
                  <Button
                    type="link"
                    size="small"
                    onClick={() => handleItemClick(item)}
                  >
                    Mark Read
                  </Button>
                ]}
              >
                <List.Item.Meta
                  avatar={
                    typeof item.avatar === 'string' ? (
                      <Avatar
                        src={item.avatar}
                        style={{
                          justifyContent: 'center',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      />
                    ) : (
                      <span
                        style={{
                          justifyContent: 'center',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        {item.avatar}
                      </span>
                    )
                  }
                  title={item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                  description={item.data}
                />
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    bottom: '0'
                  }}
                >
                  {item.datetime}
                </div>
              </List.Item>
            )}
          />
          <Button
            block
            type="text"
            onClick={handleClear}
            style={{ textAlign: 'center', color: '#146eecff', fontSize: '16px', fontWeight: 500 }}
          >
            Clear All
          </Button>
        </div>
      )}
    </div>
  )

  return (
    <Popover
      placement="bottomRight"
      content={content}
      trigger="click"
      overlayClassName="notice-popover"
    >
      <Badge
        count={notifications.length}
        overflowCount={99}
        style={{ cursor: 'pointer' }}
      >
        <BellFilled style={{ fontSize: 20, cursor: 'pointer' }} />
      </Badge>
    </Popover>
  )
}

export default DropDownNotification
